export default __webpack_public_path__ + "static/media/thumnail_youtube_6.62daf6ad.png";